import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-InfoRedShape",
  "use": "svg-icon-InfoRedShape-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-InfoRedShape\"><circle cx=\"6\" cy=\"6\" r=\"6\" /><path d=\"M5 2h2v2H5V2zm0 3h2v5H5V5z\" fill=\"red\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol